import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  alertSubject = new BehaviorSubject<any | undefined>(undefined);
  maintenanceMode = new BehaviorSubject<boolean>(false);

  showError(error: any) {
    this.alertSubject.next(error);
  }

  hideError() {
    this.alertSubject.next('');
  }
}
